import { Navigate, Route, Routes } from 'react-router-dom';
import React, { lazy } from 'react';

import { useUser } from '../../hooks/useUser';
import {
  AppRoute,
  BuildingScreenTab,
  hasPermission
} from '../../utils/navigation';

const SoknadScreen = lazy(() => import('../soknad'));
const BuildingScreenLayout = lazy(() => import('../building'));
const ExpertToolsScreen = lazy(() => import('../expertTools'));
const RegistrationScreen = lazy(() => import('../registration'));

const TiltakTab = lazy(() => import('../building/tabs/tiltak'));
const EnergyAssessment = lazy(
  () => import('../building/tabs/energyAssessment')
);
const DocumentsForEnovaApplicationWrapper = lazy(
  () => import('../building/tabs/enovaApplication')
);
const EnergyRating = lazy(() => import('../building/tabs/energyRating'));
const About = lazy(() => import('../building/tabs/about'));
const EnergyCertificateTabContent = lazy(
  () => import('../building/tabs/energyCertificateTabContent')
);

export const BuildingRoutes = () => {
  const { user } = useUser();

  return (
    <Routes>
      <Route path=":buildingId">
        <Route element={<BuildingScreenLayout />}>
          <Route
            index
            element={
              // Redirect to default tab
              <Navigate to={BuildingScreenTab.ENERGY_CERTIFICATE} replace />
            }
          />
          <Route
            path={BuildingScreenTab.ENERGY_CERTIFICATE}
            element={<EnergyCertificateTabContent />}
          />
          <Route path={BuildingScreenTab.ABOUT} element={<About />} />
          <Route
            path={BuildingScreenTab.ENERGY_RATING}
            element={<EnergyRating />}
          />
          <Route
            path={BuildingScreenTab.DOCUMENTS}
            element={<DocumentsForEnovaApplicationWrapper />}
          />
          <Route
            path={BuildingScreenTab.ENERGY_ASSESSMENT}
            element={<EnergyAssessment />}
          />
          <Route
            path={BuildingScreenTab.ENERGY_SAVING_MEASURES}
            element={<TiltakTab />}
          />
        </Route>
        <Route path="registrer-energimerke">
          <Route path=":registrationId">
            <Route path=":step?">
              <Route path=":tab?" element={<RegistrationScreen />} />
            </Route>
          </Route>
        </Route>

        <Route
          path="ny-registrering/:originalRegistrationId?"
          element={<RegistrationScreen />}
        />

        <Route path="soknad">
          <Route path=":soknadId">
            <Route path=":soknadSteg">
              <Route path=":step?">
                <Route path=":tab?" element={<SoknadScreen />} />
              </Route>
            </Route>
          </Route>
        </Route>

        <Route path="ny-soknad" element={<SoknadScreen />} />

        {hasPermission(AppRoute.EXPERT_TOOLS_VARME, user) && (
          <Route path="ekspert-varme/:area" element={<ExpertToolsScreen />} />
        )}

        {hasPermission(AppRoute.EXPERT_TOOLS_KULDE, user) && (
          <Route path="ekspert-kulde/:area" element={<ExpertToolsScreen />} />
        )}
      </Route>
    </Routes>
  );
};
